export const LOAD_VINCULOS = 'itbi-common/proprietario/LOAD_VINCULOS';
